import * as React from "react";
import { FormattedMessage } from "react-intl";
import { default as moment } from "moment";
import ClickAndCollectGreenIcon from "../../assets/images/click-and-collect-green-icon.svg";
import ClickAndCollectYellowIcon from "../../assets/images/click-and-collect-yellow-icon.svg";
import ClickAndCollectGreyIcon from "../../assets/images/click-and-collect-grey-icon.svg";
import ClickAndCollectRedIcon from "../../assets/images/click-and-collect-red-icon.svg";
import TruckGreenIcon from "../../assets/images/truck-green-icon.svg";
import TruckGreyIcon from "../../assets/images/truck-grey-icon.svg";
import TruckRedIcon from "../../assets/images/truck-red-icon.svg";
import TruckYellowIcon from "../../assets/images/truck-yellow-icon.svg";
import LocationYellowIcon from "../../assets/images/location-yellow-icon.svg";
import LocationGreenIcon from "../../assets/images/location-green-icon.svg";
import LocationRedIcon from "../../assets/images/location-red-icon.svg";
import LocationGreyIcon from "../../assets/images/location-grey-icon.svg";
import { jsxWithIntl, getMessages, getLocale } from "../../i18n/IntlRootMixin";
import ErrorBoundary from "../ErrorBoundary";
import { withReactAdapter } from "../../module-federation/withReactAdapter";

/*eslint-disable max-statements*/
function deliveryRenderData(
    deliveryMode: string | undefined,
    availability: string | undefined,
    delisted: boolean | undefined,
    hasDeliveryDate: boolean
) {
    let i18nKey;
    let fallbackKey;
    let iconClass;
    switch (deliveryMode) {
        case "METRO_DELIVERY": {
            if (delisted) {
                i18nKey = "EX_STOCK_LABEL_DELISTED";
                fallbackKey = "EX_STOCK_LABEL_DELISTED";
            } else
                switch (availability) {
                    case "UNAVAILABLE": {
                        if (hasDeliveryDate) i18nKey = "EX_STOCK_LABEL_AVAILABILITY_UNAVAILABLE_WITH_DATE";
                        else i18nKey = "EX_STOCK_LABEL_AVAILABILITY_UNAVAILABLE";
                        fallbackKey = "EX_STOCK_LABEL_AVAILABILITY_UNAVAILABLE";
                        iconClass = <TruckRedIcon />;
                        break;
                    }
                    case "UNKNOWN": {
                        if (hasDeliveryDate) i18nKey = "EX_STOCK_LABEL_AVAILABILITY_UNKNOWN_WITH_DATE";
                        else i18nKey = "EX_STOCK_LABEL_AVAILABILITY_UNKNOWN";
                        fallbackKey = "EX_STOCK_LABEL_AVAILABILITY_UNKNOWN";
                        iconClass = <TruckGreyIcon />;
                        break;
                    }
                    case "AVAILABLE": {
                        if (hasDeliveryDate) i18nKey = "EX_STOCK_LABEL_AVAILABILITY_AVAILABLE_WITH_DATE";
                        else i18nKey = "EX_STOCK_LABEL_AVAILABILITY_AVAILABLE";
                        fallbackKey = "EX_STOCK_LABEL_AVAILABILITY_AVAILABLE";
                        iconClass = <TruckGreenIcon />;
                        break;
                    }
                    case "LIMITED": {
                        if (hasDeliveryDate) i18nKey = "EX_STOCK_LABEL_AVAILABILITY_LIMITED_WITH_DATE";
                        else i18nKey = "EX_STOCK_LABEL_AVAILABILITY_LIMITED";
                        fallbackKey = "EX_STOCK_LABEL_AVAILABILITY_LIMITED";
                        iconClass = <TruckYellowIcon />;
                        break;
                    }
                    default: {
                        i18nKey = "EX_STOCK_LABEL_DELISTED";
                        fallbackKey = "EX_STOCK_LABEL_DELISTED";
                        iconClass = <TruckGreyIcon />;
                        break;
                    }
                }
            return {
                iconClass: iconClass,
                deliveryClassName: "ex-delivery-metro",
                i18n: i18nKey,
                fallbackKey: fallbackKey
            };
        }
        case "STORE": {
            if (delisted) i18nKey = "EX_STOCK_LABEL_DELISTED";
            else
                switch (availability) {
                    case "UNAVAILABLE": {
                        i18nKey = "EX_STOCK_LABEL_STORE_AVAILABILITY_UNAVAILABLE";
                        iconClass = <LocationRedIcon />;
                        break;
                    }
                    case "UNKNOWN": {
                        i18nKey = "EX_STOCK_LABEL_STORE_AVAILABILITY_UNKNOWN";
                        iconClass = <LocationGreyIcon />;
                        break;
                    }
                    case "AVAILABLE": {
                        i18nKey = "EX_STOCK_LABEL_STORE_AVAILABILITY_AVAILABLE";
                        iconClass = <LocationGreenIcon />;
                        break;
                    }
                    case "LIMITED": {
                        i18nKey = "EX_STOCK_LABEL_STORE_AVAILABILITY_LIMITED";
                        iconClass = <LocationYellowIcon />;
                        break;
                    }
                    default: {
                        i18nKey = "EX_STOCK_LABEL_DELISTED";
                        iconClass = <LocationGreyIcon />;
                        break;
                    }
                }
            return {
                iconClass: iconClass,
                deliveryClassName: "ex-delivery-store",
                i18n: i18nKey
            };
        }
        case "PICKUP": {
            switch (availability) {
                case "UNAVAILABLE": {
                    i18nKey = "EX_STOCK_LABEL_AVAILABILITY_UNAVAILABLE";
                    iconClass = <ClickAndCollectRedIcon />;
                    break;
                }
                case "UNKNOWN": {
                    i18nKey = "EX_STOCK_LABEL_PICKUP_AVAILABILITY_UNKNOWN";
                    iconClass = <ClickAndCollectGreyIcon />;
                    break;
                }
                case "LIMITED": {
                    i18nKey = "EX_STOCK_LABEL_PICKUP";
                    iconClass = <ClickAndCollectYellowIcon />;
                    break;
                }
                case "AVAILABLE": {
                    i18nKey = "EX_STOCK_LABEL_PICKUP";
                    iconClass = <ClickAndCollectGreenIcon />;
                    break;
                }
                default: {
                    i18nKey = "EX_STOCK_LABEL_PICKUP";
                    iconClass = <ClickAndCollectGreyIcon />;
                    break;
                }
            }
            return {
                iconClass: iconClass,
                deliveryClassName: "ex-delivery-pickup",
                i18n: i18nKey
            };
        }
        case "PARCEL_DELIVERY": {
            switch (availability) {
                case "UNAVAILABLE": {
                    i18nKey = "EX_STOCK_LABEL_AVAILABILITY_UNAVAILABLE";
                    fallbackKey = "EX_STOCK_LABEL_AVAILABILITY_UNAVAILABLE";
                    iconClass = <TruckRedIcon />;
                    break;
                }
                case "LIMITED": {
                    i18nKey = "EX_STOCK_LABEL_DELIVERY_LIMITED";
                    fallbackKey = "EX_STOCK_LABEL_DELIVERY";
                    iconClass = <TruckYellowIcon />;
                    break;
                }
                case "AVAILABLE": {
                    i18nKey = "EX_STOCK_LABEL_DELIVERY";
                    fallbackKey = "EX_STOCK_LABEL_DELIVERY";
                    iconClass = <TruckGreenIcon />;
                    break;
                }
                case "UNKNOWN": {
                    i18nKey = "EX_STOCK_LABEL_DELIVERY";
                    fallbackKey = "EX_STOCK_LABEL_DELIVERY";
                    iconClass = <TruckGreyIcon />;
                    break;
                }
                default: {
                    i18nKey = "EX_STOCK_LABEL_DELIVERY";
                    fallbackKey = "EX_STOCK_LABEL_DELIVERY";
                    iconClass = <TruckGreyIcon />;
                    break;
                }
            }
            return {
                iconClass: iconClass,
                deliveryClassName: "ex-delivery-parcel",
                i18n: i18nKey,
                fallbackKey: fallbackKey
            };
        }
        case "EXPRESS_DELIVERY": {
            switch (availability) {
                case "UNAVAILABLE": {
                    i18nKey = "EX_STOCK_LABEL_AVAILABILITY_UNAVAILABLE";
                    fallbackKey = "EX_STOCK_LABEL_AVAILABILITY_UNAVAILABLE";
                    iconClass = <TruckRedIcon />;
                    break;
                }
                case "LIMITED": {
                    i18nKey = "EX_STOCK_LABEL_EXPRESS_LIMITED";
                    fallbackKey = "EX_STOCK_LABEL_EXPRESS";
                    iconClass = <TruckYellowIcon />;
                    break;
                }
                case "AVAILABLE": {
                    i18nKey = "EX_STOCK_LABEL_EXPRESS";
                    fallbackKey = "EX_STOCK_LABEL_EXPRESS";
                    iconClass = <TruckGreenIcon />;
                    break;
                }
                case "UNKNOWN": {
                    i18nKey = "EX_STOCK_LABEL_EXPRESS";
                    fallbackKey = "EX_STOCK_LABEL_EXPRESS";
                    iconClass = <TruckGreyIcon />;
                    break;
                }
                default: {
                    i18nKey = "EX_STOCK_LABEL_EXPRESS";
                    fallbackKey = "EX_STOCK_LABEL_EXPRESS";
                    iconClass = <TruckGreyIcon />;
                    break;
                }
            }
            return {
                iconClass: iconClass,
                deliveryClassName: "ex-delivery-express",
                i18n: i18nKey,
                fallbackKey: fallbackKey
            };
        }
        default:
            return {
                iconClass: <TruckGreyIcon />,
                deliveryClassName: "ex-delivery-metro",
                i18n: "EX_STOCK_LABEL_AVAILABILITY_UNKNOWN",
                fallbackKey: "EX_STOCK_LABEL_AVAILABILITY_UNKNOWN"
            };
    }
}

type Props = {
    availability: string | undefined;
    deliveryMode: string | undefined;
    deliveryDate: string | undefined | null;
    delisted: boolean | undefined;
    storeName: string | undefined | null;
};

type PropsInner = Props & {
    locale: string;
    messages: {
        [translationKey: string]: string;
    };
};
/*eslint-enable max-statements*/

function AvailabilityDetailsInner({
    availability,
    deliveryMode,
    deliveryDate,
    delisted,
    storeName,
    locale,
    messages
}: PropsInner) {
    const renderData = deliveryRenderData(deliveryMode, availability, delisted, !!deliveryDate);
    const key = renderData.i18n in messages || !renderData.fallbackKey ? renderData.i18n : renderData.fallbackKey;

    let formattedDate = "";
    let dateFormat;

    if (!delisted && availability !== "UNAVAILABLE" && deliveryMode !== "STORE") {
        let dateFormatKey = key + "_DATE";
        if (!(dateFormatKey in messages)) {
            dateFormatKey = "EX_STOCK_LABEL_DELIVERY_DATE";
        }
        dateFormat = messages[dateFormatKey] || "DD-MM-YYYY";
        formattedDate = deliveryDate ? moment(deliveryDate).locale(locale).format(dateFormat) : "";
    }

    return (
        <span className={renderData.deliveryClassName}>
            <span className={"state " + availability}>
                <span>{renderData.iconClass}</span>
                <span>&nbsp;</span>
                <span>
                    <FormattedMessage id={key} values={{ date: formattedDate, store: storeName || "" }} />
                </span>
            </span>
        </span>
    );
}

function AvailabilityDetailsWithoutErrorBoundary(props: Props) {
    const locale = getLocale();
    const messages = getMessages("EXPLORE");
    return <>{jsxWithIntl(<AvailabilityDetailsInner {...props} messages={messages} locale={locale} />, "EXPLORE")}</>;
}

export function AvailabilityDetails(props: Props) {
    return (
        <ErrorBoundary>
            <AvailabilityDetailsWithoutErrorBoundary {...props} />
        </ErrorBoundary>
    );
}

export default withReactAdapter(AvailabilityDetails);
// Exported for testing
export { AvailabilityDetailsInner as AvailabilityDetailsIntl };
